module.exports = __webpack_public_path__ + "img/icon-yandex.e4034362.svg";